import styled from 'styled-components'

export const StyledSearchFiltersToggle = styled.div`
    width: 100%;
    clear: both;
`
